import { useEffect, useRef } from 'react';
import { markPointAsSeen } from '@routes/sidebar/learning/model/learning.slice.ts';
import { rankPointToToast } from '@utils/rankPointToToast.ts';

import { useAppDispatch, useAppSelector } from './reduxHooks.ts';
import { useNotify } from './useNotify.ts';

export const usePointsNotifications = () => {
    const dispatch = useAppDispatch();
    const notify = useNotify();
    const userPoints = useAppSelector((s) => s.learning.userScoreResponse.unseenScores);
    const processed = useRef<Set<string>>(new Set());

    useEffect(() => {
        if (!userPoints?.length) return;

        const pending = userPoints.filter((p) => !processed.current.has(p.eventDateTimeUTC));

        if (!pending.length) return;

        pending.forEach((point) => {
            processed.current.add(point.eventDateTimeUTC);

            dispatch(markPointAsSeen(point.eventDateTimeUTC))
                .then(() => {
                    rankPointToToast(point, notify);
                })
                .catch(() => {
                    processed.current.delete(point.eventDateTimeUTC);
                });
        });
    }, [userPoints, dispatch, notify]);
};
